import script from "./SkewedDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SkewedDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SkewedDropdown.vue?vue&type=style&index=0&id=7dd34e2a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd34e2a"]])

export default __exports__